import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAppSelector } from '../../app/hooks';
import { loaderGif } from '../../assets/images/login';
import styles from '../../features/formAfterSignUp/FormAfterSignUp.module.css';

type TProps = {
  showSuccessModal?: boolean;
  setShowSuccessModal?: React.Dispatch<React.SetStateAction<boolean>>;
  img?: string;
  description?: string;
  header?: string;
  bottomText?: string | JSX.Element;
  closePreviousModal?: () => void;
  proceedText?: string;
};

export default function ForgotPasswordSuccessModal({
  showSuccessModal = false,
  setShowSuccessModal = () => {
    return;
  },
  img = loaderGif,
  header = 'Successful',
  description = '',
  bottomText,
  closePreviousModal = () => {
    return;
  },
  proceedText = 'Proceed',
}: TProps) {
  useEffect(() => {
    showSuccessModal && closePreviousModal();
  }, [closePreviousModal, showSuccessModal]);

  //   console.log(showSuccessModal);
  return (
    <>
      {showSuccessModal ? (
        <>
          <div className='fixed inset-0 z-10 overflow-y-auto'>
            <div className='fixed inset-0 w-full h-full bg-black opacity-40'></div>
            <div className='flex items-center min-h-screen px-6 py-4'>
              <div className='relative p-[2.6em] sm:py-[100px] sm:px-[5rem] mx-auto bg-white rounded-md shadow-lg'>
                <div className='sm:mt-[1.5em] max-w-[300px] sm:flex justify-center'>
                  <div className=' text-center sm:text-left'>
                    <div className='mb-2'>
                      <img src={img} alt='success.gif' className='h-[100px] sm:h-[180px]' />
                    </div>
                    <div className='text-[#229698] font-bold text-[24px] font-[Poppins] leading-[30px]'>
                      {header}
                    </div>
                    <div className='text-xs mt-2 mb-6 font-[Poppins]'>{description}</div>
                    {/* <div className='items-center gap-2 mt-3 sm:flex'>
                      <button
                        className={[
                          styles.bgColor,
                          'w-56 md:w-72 mt-2 p-2.5 flex-1 text-white outline-none font-[Poppins]',
                        ].join(' ')}
                        onClick={() => setShowSuccessModal(false)}
                      >
                        {proceedText}
                      </button>
                    </div>
                    {bottomText && <div className='font-[Poppins]'>{bottomText}</div>} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
}
